// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://prodbackend.eurocross.in",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
